import { useLayoutEffect, useRef, type RefObject } from 'react';

/**
 * A ref holding the value from the latest committed render. Code that resumes after an `await`
 * reads it to see the form as it is now, not as it was when the click started.
 */
export function useLatest<T>(value: T): RefObject<T> {
  const latest = useRef(value);
  useLayoutEffect(() => {
    latest.current = value;
  });
  return latest;
}
